module.exports = __webpack_public_path__ + "img/user.7de5e5f7.svg";